import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {AppLoginSubjectContainerModel} from '../../../../../models/aggregates/id';


@Injectable({
  providedIn: 'root'
})
export class IdentityPasswordService extends BaseApiTemplateService<AppLoginSubjectContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + '/identity/password';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + '/identity/password';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + '/identity/password';
    this.httpClient = http;
  }

}
